module.exports = __webpack_public_path__ + "static/media/adriano_italian.6f9d2990.mp3";